import React from 'react';
import { Title } from 'bloomer/lib/elements/Title';
import Bold from '../../Bold';

export default function ParticipationPreamble({
	startDate,
	endDate,
	averagePerDay,
	type,
	animalType
}) {
	return (
		<div>
			<Title tag="h4">{type}:</Title>
			<p>
				Between <Bold>{startDate}</Bold> and{' '}
				<Bold>{endDate}</Bold> there was an average of{' '}
				<Bold>{averagePerDay.toFixed(2)} {animalType}s</Bold> who
				participated in a
				{type} enrichment each day. The breakdown is shown below.
			</p>
		</div>
	);
}
